import React from 'react';
import BaseField, {
	BaseFieldProps,
} from '../../Base/Components/Inputs/BaseField/BaseField';
import TermItemRadioList from './TermItemRadioList';
import { RadioListItem } from '../../../Components/Form/components/RadioList';

interface Props extends BaseFieldProps {
	termType: string;
	onChange?: (value: RadioListItem) => void;
	inLine?: boolean;
}

const TermItemRadioListField: React.FC<Props> = props => (
	<BaseField {...props}>
		<TermItemRadioList
			termType={props.termType}
			onChange={props.onChange}
			inLine={props.inLine}
		/>
	</BaseField>
);

export default TermItemRadioListField;
